import SVG from './svg';

export default () => {

    return (
        <div className="loader-page animate__animated">
            <SVG />
        </div>
    )
}